<template>
  <FormHeading :h="3">
    {{ $tt('visa_select') }}
  </FormHeading>
  <FormBlock>
    <AppRow>
      <ProductRadio v-model="form.product" :products />
      <ProductInfoBox :product="form.product" :urgency="form.urgency" />
    </AppRow>
  </FormBlock>
  <AppRow>
    <div>
      <UrgencyField
        v-if="form.product.urgencies"
        v-model="form.urgency"
        :urgencies="form.product.urgencies"
        class="mb-6"
      />
      <QuantitySelect v-model="form.quantity" :product="form.product" />
    </div>
    <div>
      <BasketSummary :form />
      <CouponFields v-model="form.discount" />
    </div>
  </AppRow>

  <AppAlert v-if="form.product.consulate_payment_countries?.includes($branch.baseCountry)" class="my-6">
    {{ $tt('consulate_payment_note') }}
  </AppAlert>
</template>

<script setup lang="ts">
import type { Product, VisaForm } from '~/types';

defineProps<{
  form: VisaForm;
  products: Product[];
}>();
</script>